import { AxiosError, AxiosResponse } from "axios";
import { ILaunchOsObjectParams, ISendPdfOs } from "../../interfaces/IOs";
import protheusProvider from "../providers/protheus.provider";

export class OsService {
  public async getOs(os: number, analista: string, token: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get(`WSRESTOS/${os}`, {
        params: {
          analista,
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async launchOs(objectParams: ILaunchOsObjectParams): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`WSRESTOS`, objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async deleteOS(numberOS: string, token: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.delete(`WSRESTOS/${numberOS}`, {
        params: {
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async sendPdfOS(objectParams: ISendPdfOs): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`WSSENDMAIL`, objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}